import axios, { AxiosResponse } from 'axios';
import { DashboardDataResponse } from '../types/dashboard';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/v1/dashboard`;

export async function getDashboardDataByPersonId(personId: string): Promise<AxiosResponse<DashboardDataResponse>> {
  return await axios.get(`${API_BASE_URL}/${personId}`);
}
